{
    "404": "Oh no! Abbiamo cercato nel mare e non riusciamo a trovare la pagina!",
    "appError": {
        "title": "Qualcosa è andato storto",
        "description": "L'app ha riscontrato un problema imprevisto. Prova a ricaricarla o torna alla tua area di lavoro. Se il problema persiste, contatta l'assistenza.",
        "home": "Torna all'area di lavoro"
    }
}
